import * as React from 'react';
import './StickyBanner.css';

export interface Props {
    className?: string;
}

// Doesn't work in IE... yet.

export class StickyBanner extends React.PureComponent<Props> {
    static defaultProps: Partial<Props> = {
        className: ''
    };

    constructor(props: Props) {
        super(props);
    }

    render() {
        return (
            <div className={`sticky-banner-blue ${this.props.className}`} data-testid="sticky-banner">
                {this.props.children}
            </div>
        );
    }
}